module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei1.svg";